<template>
  <div class="production-information-content">
    <v-container container--fluid grid-list-md>
       <v-row justify="space-between" align="center">
        <v-col cols="12" sm="12" md="6" v-for="(item, index) in items" :key="index">
          <v-select
            v-if="item.type === 'select'"
            :items="item.selectItems"
            :label="item.text"
            v-model="clientInfo[item.key]"
            :error="isFieldInvalid(item.key)"
            outlined
          ></v-select>
          <v-checkbox
            v-if="item.type === 'checkbox'"
            :label="item.text"
            v-model="clientInfo[item.key]"
          ></v-checkbox>
          <v-text-field
            v-if="item.type === 'text'"
            v-model="clientInfo[item.key]"
            :label="item.text"
            :error="isFieldInvalid(item.key)"
            outlined
          ></v-text-field>

            <v-switch
              v-if="item.type === 'switch'"
              :label="item.text"
              v-model="clientInfo[item.key]"
            ></v-switch>

            <template v-if="item.type === 'combo'">
              <v-row dense align="center" v-if="clientInfo.pick_pack">
                <v-col cols="6">
                  <v-select
                    :items="item.selectItems"
                    item-text="text"
                    item-value="value"
                    label="PP Limit Type"
                    v-model="clientInfo.pp_box_limit_type"
                    clearable
                  ></v-select>
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    v-if="clientInfo.pp_box_limit_type === 'items_per_box'"
                    v-model.number="clientInfo.pp_weight_per_box"
                    label="PP Items per Box"
                    type="number"
                  ></v-text-field>
                  <v-text-field
                    v-else-if="clientInfo.pp_box_limit_type === 'weight_per_box'"
                    v-model.number="clientInfo.pp_weight_per_box"
                    label="PP Weight per Box"
                    type="number"
                  ></v-text-field>
                  <v-text-field
                    v-else
                    disabled
                    label="Select type first"
                  ></v-text-field>
                </v-col>
              </v-row>
            </template>

          </v-col>
         </v-row>
      </v-container>
  </div>
</template>

<script>
  // @group EditClient
  // Client Production Information tab for EditClientPage
  import axios from "axios";

  export default {
    name: "ProductionInformation",
    props: {
      // Client Object
      clientInfo: Object,
    },
    data() {
      return {
        items: [
          {text: 'Production Address', key: 'production_address', type: 'text'},
          {text: 'Production Phone', key: 'production_phone', type: 'text'},
          {
            text: 'Delivery Frequency',
            key: 'frequency',
            type: 'select',
            selectItems: ['Weekly', 'Fortnightly', 'Monthly']
          },
          {text: 'Packaging', key: 'packaging', type: 'select', selectItems: ['Cardboard', 'Polystyrene']},
          {text: 'Multiple Sizes', key: 'multiple_sizes', type: 'select', selectItems: ['Yes', 'No']},
          {text: 'Boxes per Pallet', key: 'boxes_per_pallet', type: 'text'},
          {text: 'Dimensions', key: 'dimensions', type: 'text'},
          {text: 'Weight', key: 'weight', type: 'text'},
          {text: 'Product Type', key: 'product_type', type: 'select', selectItems: ['Fresh', 'Frozen']},
          {text: 'Production Items per Box', key: 'production_items_per_box', type: 'text'},
          {text: 'Instructions on box', key: 'instruction_on_box', type: 'checkbox'},
          {text: 'Data Validation', key: 'data_validation', type: 'checkbox'},
          {text: 'Pick Pack', key: 'pick_pack', type: 'switch'},
          {text: 'Storage Only', key: 'storage_only', type: 'switch'},
          {
            text: 'Pick Pack Box Limit',
            type: 'combo',
            selectItems: [
              { text: 'Items per Box', value: 'items_per_box' },
              { text: 'Weight per Box', value: 'weight_per_box' }
            ]
          }
        ]

      }
    },
    methods:{

    },


    computed: {
      invalidFields() {
        return this.$store.state.invalidFields || [];
      },
      isFieldInvalid() {
        return (fieldName) => this.invalidFields.includes(fieldName);
      }
    },
    asyncComputed: {

    }
  }
</script>

<style scoped>
.production-information-content {}

.v-text-field,
.v-checkbox {
  margin-bottom: 8px;
}

.v-text-field.v-text-field--outlined >>> .v-input__control {
  min-height: 56px;
}

.v-text-field.v-text-field--outlined >>> .v-input__slot {
  min-height: 48px;
}
</style>



// WEBPACK FOOTER //
// src/components/util/Clients/ProductionInformation.vue